import React, { useEffect, useRef, useState } from 'react';
import {startCase} from 'lodash';
import query from 'query-string';
import ReactPlayer from 'react-player';
import {RightCircleFilled} from '@ant-design/icons';
import axios from 'axios';
import moment from 'moment';
import './style.scss';
import professional from '../../assets/images/professional.png';
import calendar from '../../assets/images/Calendar.png';
import profile from '../../assets/images/profile.png';
import closed from '../../assets/images/Closed3x.png';
import missed from '../../assets/images/Missed3x.png';
import tick from '../../assets/images/check.png';
import toBeVerified from '../../assets/images/ToBeVerified3x.png';
import reOpened from '../../assets/images/ReOpened3x.png';
import deleteIcon from '../../assets/images/Delete.png';
import back from '../../assets/images/Back.png';
import cancel from '../../assets/images/Cancel.png';
import camera from '../../assets/images/camera.png';
import attachment from '../../assets/images/Attachment.png';
import { message, Modal, Upload } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { AUTH_TOKEN, getStatusLabel, getStatusStyle } from '../../constants';
import { UploadOutlined } from '@ant-design/icons';import * as firebase from 'firebase/app';
import 'firebase/storage';
import { setEvent, setPageViewAnalytics } from '../../utils/analytics';

export class FileUpload {
    key;

    name;

    url;

    file;

    constructor(file) {
        this.file = file;
    }
}

export const uploadFileToFirebase = (basePath, fileUpload, progress) => new Promise((resolve, reject) => {
    const storageRef = firebase.storage().ref();
    const uploadTask = storageRef.child(`${basePath}/${fileUpload.file.name}`).put(fileUpload.file);

    uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot) => {
            // in progress
            const snap = snapshot;
            const perc = Math.round((snap.bytesTransferred / snap.totalBytes) * 100);
            progress({ percent: perc }, fileUpload.file);
        },
        () => {
            // fail
            reject();
        },
        () => {
            // success
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                fileUpload.url = downloadURL;
                fileUpload.name = fileUpload.file.name;
                resolve();
            });
        },
    );
});


const IssueDetails = (props) => {
    const bodyRef = useRef(null);
    const overlayRef = useRef(null);
    const overlayBodyRef = useRef(null);
    let navigate = useNavigate();
    let location = useLocation();
    const [issueType, setIssueType] = useState('opened');
    const [updated, updateList] = useState(false);
    const [nextMove, setNextMove] = useState('');
    const [baseData, setBaseData] = useState({});
    const [missingField, setMissingField] = useState([]);
    const [videoIdx, setVideoIdx] = useState(new Set());
    const [imageProcessing, setImageProcessing] = useState(false);
    const [viewDetails, setViewDetails] = useState(false);
    const [overlayVisible, setOverlayVisible] = useState(false);
    const [mediaOverlay, setMediaOverlayVisible] = useState(false);
    const [previewOverlay, setPreviewOverlayVisible] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [limitToast, setLimitToast] = useState(false);
    const [errorToast, setErrorToast] = useState(false);
    const [loading, setLoading] = useState(false);
    const [pageAnalytics, setPageAnalytics] = useState(false);
    const [approvalStatus, markApprovalStatus] = useState('');
    const [comment, setComment] = useState('');
    const [issueList, setIssueList] = useState([]);
    const [timelines, setTimelines] = useState([]);
    const [stageName, setStageName] = useState('');
    const [taskName, setTaskName] = useState('');
    const [qcName, setQcName] = useState('');
    const [title, setTitle] = useState('');
    const [imageList, setImageList] = useState([]);
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [description, setDescription] = useState('');
    const searchIssues = (payload) => {
        if (baseData && baseData.token) {
            axios.post(`https://guardian-professional.bricknbolt.com/inspectionService/api/v3/issue/search`, payload, {
                headers: {
                    'Authorization': `Bearer ${baseData.token}`
                },
                params: {
                    loadDetails:true
                },
            }).then(res => {
                setIssueList(res.data.responseData.data);
                setLoading(false);
            }).catch(() => {
                setLoading(false);
                setErrorToast(true);
            });
        }
    }
    const getStageValue = (targetSnag) => {
        let stages = '';
        targetSnag && targetSnag.stageWiseData && targetSnag.stageWiseData.map((item, idx) => {
            if (item.refChild && item.refChild.refName) {
                stages = `${stages}${idx !== 0 ? ', ' : ''}${item.refChild.refName}`;
            }
          });
        setStageName(stages)
        return stages;
    };
    const getTaskValue = (targetSnag) => {
        let task = '';
        targetSnag && targetSnag.stageWiseData && targetSnag.stageWiseData.map((item, idx) => {
            if (item && item.refChild && item.refChild.refChild && item.refChild.refChild.refName) {
                task = `${task}${idx !== 0 ? ', ' : ''}${item.refChild.refChild.refName}`;
            }
          });
        setTaskName(task)
        return task;
    };
    const getQcValue = (targetSnag) => {
        let task = '';
        targetSnag && targetSnag.stageWiseData && targetSnag.stageWiseData.map((item, idx) => {
            if (item && item.refChild && item.refChild.refChild && item.refChild.refChild.refChild && item.refChild.refChild.refChild.refName) {
                task = `${task}${idx !== 0 ? ', ' : ''}${item.refChild.refChild.refChild.refName}`;
            }
          });
        setQcName(task)
        return task;
    };
    useEffect(() => {
        setLoading(true);
        let qcData = baseData.qcId ? {
            refId: [(baseData.qcId || '')]
        }: {};
        searchIssues({
            crnId: baseData.crnId,
            issueId: (location.state.issueId || ''),
            ...qcData,
        });
    }, [issueType, viewDetails, baseData]);

    useEffect(() => {
        setBaseData(query.parse(location.search));
    }, []);

    useEffect(() => {
        if (!pageAnalytics) {
            setPageViewAnalytics({ pageUrl: window.location.pathname, title: 'Issues Page' });
            setPageAnalytics(true);
        }
        setEvent({
            category: 'User',
            action: 'Prof_SE_Details',
            label: 'Prof_SE_Details',
            nonInteraction: true
        });
    },[baseData.token, pageAnalytics]);

    useEffect(() => {
        if(errorToast) {
            setTimeout(()=>setErrorToast(false), 1500);
        }
    },[errorToast]);

    const getStatusRole = (data) => {
        if (data && data[0] && data[0].includes('BNB_CONTRACTOR')){
            return 'SE';
        } else if (data && data[0] && data[0].includes('BNB_SITE_ENGINEER')){
            return 'Contractor';
        } else {
            return 'SE';
        }
    }
    const getCreatedByRole = (data) => {
        if (!!data) {
            if (data.includes('BNB_CONTRACTOR')){
                return 'Contractor';
            } else if (data.includes('BNB_SITE_ENGINEER')){
                return 'SE';
            } else if (data.includes('BNB_PROJECT_MANAGER')){
                return 'PM';
            } else {
                return 'SE';
            }
        } else {
            return '';
        }
    }

    useEffect(() => {
        if (issueList[0]) {
            getStageValue(issueList[0]);
            getTaskValue(issueList[0]);
            getQcValue(issueList[0]);
            setTitle(issueList[0].title);
            setDescription(issueList[0].description);
            setTimelines(issueList[0].timelines);
        }
    },[issueList]);

    const handleFileRemoval = (removedFile) => {
        const data = [];
        imageList.map((file) => {
            if (file === removedFile) {
                return;
            }
            data.push(file);
        })
        const designUrls = data;
        if (designUrls.length === 0 && !missingField.includes('images')) {
            let errorFields = missingField;
            errorFields.push('images');
            setMissingField(errorFields);
        }
        setImageList(designUrls);
        updateList(!updated);
    };

    const getNextMoveText = () => {
        if (nextMove === 'TO_BE_VERIFIED') {
            return 'Enter supporting media and comments to mark this issue as completed.'
        }
        if (nextMove === 'MISSED_BY_CONTRACTOR') {
            return 'Enter reason for not completing this issue.'
        }
        if (nextMove === 'MISSED') {
            return 'Enter reason for not completing this issue.'
        }
        if (nextMove === 'COMPLETED') {
            return 'Enter comment with uploading completed issue image.'
        }
        if (nextMove === 'RE_OPENED') {
            return 'Enter reason for disapproving & re-opening the issue.'
        }
        if (nextMove === 'CLOSED') {
            return 'Enter reason for approving & closing the issue.'
        }
        return 'Enter Comment/Reason.'
    };

    const getStampIcon = (status) => {
        switch(status) {
            case 'CLOSED': return closed;
            case 'MISSED': return missed;
            case 'MISSED_BY_CONTRACTOR': return missed;
            case 'TO_BE_VERIFIED': return toBeVerified;
            case 'RE_OPENED': return reOpened;
            default: return null;
        }
    }

    const createTimeline = () => {
        setLoading(true);
        let statusData = nextMove ? { status: nextMove } : {}
        let data = {
            ...statusData,
            issueId: (location.state.issueId || ''),
        comment,
        createdBy: baseData.userId,
        createdByName: baseData.userName,
        mediaUrls: imageList,
        createdByRole: baseData.role,
        crnId: baseData.crnId,
        }
        axios.post(`https://guardian-professional.bricknbolt.com/inspectionService/api/v3/issue/timeline/create`, data, {
            headers: {
                'Authorization': `Bearer ${baseData.token}`
            }
        }).then(res => {
            data = res.data;
            setImageList([]);
            setComment('');
            setNextMove('');
            updateList(!updated);
            setOverlayVisible(false);
            setLoading(false);
            let qcData = baseData.qcId ? {
                refId: [(baseData.qcId || '')]
            }: {};
            searchIssues({
                crnId: baseData.crnId,
                issueId: (location.state.issueId || ''),
                ...qcData,
            });
        }).catch(() => {
            setLoading(false);
            setErrorToast(true);
        })
    }

  let list = window.mediaList;
  useEffect(() => {
    if(list && typeof list === 'string'){
        list = list.split(',');
        list[0] = list[0].replace('[', '');
        list[(list.length-1)] = list[(list.length-1)].replace(']', '');
        setImageList([...imageList, ...list]);
        if (!!([...imageList, ...list].length) && missingField.includes('images')) {
            setMissingField(missingField.filter((i,v) => i !== 'images'));
        }
        window.mediaList = [];
        setImageProcessing(false);
        let link = document.createElement('input');
        link.setAttribute('value', '');
        document.body.appendChild(link);
        document.body.removeChild(link);
    } else if(imageProcessing) {
        setImageProcessing(false);
    }
  },[updated]);

  useEffect(() => {
    if (imageList.length === 0) {
        window.mediaList = [];
    }
    setMediaOverlayVisible(false);
  },[imageList.length]);

  useEffect(() => {
    if(limitToast) {
        setTimeout(()=>setLimitToast(false), 1000);
    }
  },[limitToast]);

  useEffect(() => {
    const interval = setTimeout(() => {
        if (updated) {
            updateList(false);
        } else {
            updateList(true);
        }
    },2000);

    return () => {
        clearTimeout(interval);
    }
  }, [updated]);

  
  const isVideo = (url) => {
    if (url && typeof url === 'string'){
        let part = url.split('.');
        if(part[(part.length - 1)] === 'mp4'){
            return true;
        }
        else if(part[(part.length - 1)] === 'jpeg' || part[(part.length - 1)] === 'jpg' || part[(part.length - 1)] === 'png') {
            return false;
        }
    }
    else return null;
}

const isViewOnly = () => {
    if (baseData.viewOnly && baseData.viewOnly === 'true') {
        return true;
    }
    return false;
}

    return (
        <div className='background-div'>
            <div className='app-header'>
                <span onClick={()=>{
                        if (window.history.state.idx === 0) {
                            // eslint-disable-next-line no-undef
                            android.exitWebView();
                        } else {
                            navigate(`${location.state.reverseUrl}${location.search}`, {replace: true, state: {
                                issueType: location.state.issueType
                            }})
                        }
                    }} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginLeft: '20px'}}>
                    <img src={back} height={25} width={15} />
                </span>
                <label style={{ flex: 2, justifyContent: 'flex-start' }}>Issues Details</label>
            </div>
        <div ref={bodyRef} className='issues-body' style={{ height: (window.innerHeight - 100) }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'flex-start', padding: '10px', width: '95%', overflowY: 'auto' }}>
                <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                    {(issueList[0] && issueList[0].status && getStampIcon(issueList[0].status)) && <div className='status-stamp' style={{ width: '30%'}}>
                        <img src={getStampIcon(issueList[0].status)} height={10} width={10} />
                    </div>}
                    <div style={{ display: 'flex', flexDirection: 'column', width: issueList[0] && issueList[0].status && getStampIcon(issueList[0].status) ? '70%' : '100%'}}>
                        <label className='field-name' style={{width: '95%'}}>Stage</label>
                        <span className='field-value' style={{width: '95%'}}>{stageName}</span>
                    </div>
                </div>
                {!!taskName && <><label className='field-name'>Task</label>
                <span className='field-value'>{taskName}</span></>}
                {!!qcName && <><label className='field-name'>Quality Check</label>
                <span className='field-value'>{qcName}</span></>}
                <label className='field-name'>Raised On:</label>
                <span className='field-value'>
                    <span className='icon-titles'>
                        <img src={calendar} height={10} width={10} />
                        {issueList && issueList[0] && moment(issueList[0].createdAt).format('DD MMM, YYYY')}
                    </span>
                </span>
                <label className='field-name'>Raised By:</label>
                <span className='field-value'>
                    <span className='icon-titles'>
                        <img src={professional} height={10} width={10} />
                        {issueList[0] && issueList[0].createdByName}
                    </span>
                </span>
                {issueList && issueList[0] && issueList[0].mediaUrls && (issueList[0].mediaUrls.length > 0) && <label className='field-name'>{`Media Uploaded By ${getCreatedByRole(issueList[0].createdByRole)}:`}</label>}
                {issueList && issueList[0] && issueList[0].mediaUrls && (issueList[0].mediaUrls.length > 0) && <span className='field-value'>
                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                        {issueList[0] && issueList[0].mediaUrls && issueList[0].mediaUrls.map((item, idx) => (<div className='issue-img'>
                        {isVideo(item) ? 
                        <div className='player-div' style={{ backgroundColor: 'black' }} onClick={() => {
                            setPreviewUrl(item);
                            setPreviewOverlayVisible(true);
                        }}>
                        {videoIdx.has(idx) && 
                            <div style={{position:'relative', zIndex: 100, display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}><div className="overlay-loader"></div></div>}
                                <ReactPlayer 
                                    muted
                                    loop
                                    playing
                                    height={'100%'}
                                    width={'100%'}
                                    stopOnUnmount
                                    onClickPreview={() => {
                                        setPreviewUrl(item);
                                        setPreviewOverlayVisible(true);
                                    }}
                                    onBuffer={(data)=>{
                                        let idxs = new Set(videoIdx);
                                        idxs.add(idx);
                                        setVideoIdx(idxs);
                                    }}
                                    onBufferEnd={(data)=>{
                                        let idxs = new Set(videoIdx);
                                        idxs.delete(idx);
                                        setVideoIdx(idxs);
                                    }}
                                    style={{ position: 'absolute', top: 0, left:0}}
                                    url={item}
                                />
                                </div>
                        // <video width={'100%'} height={'100%'} controls autoPlay={false}>
                        //     <source src={item} type="video/mp4"/>
                        // </video> 
                        : <img src={item} width={'70px'} height={'71px'} onClick={() => {
                            setPreviewUrl(item);
                            setPreviewOverlayVisible(true);
                        }} />}
                        </div>))}
                    </div>
                </span>}
                <label className='field-name'>{`${issueList[0] && issueList[0].issueType==='SNAG' ? 'Snag' : 'Hitch'} Title`}</label>
                <span className='field-value'>{title}</span>
                {!!description && <>
                    <label className='field-name'>{`${issueList[0] && issueList[0].issueType==='SNAG' ? 'Snag' : 'Hitch'} Description`}</label>
                    <span className='field-value'>{description}</span>
                </>}
                {timelines && (timelines.length !== 0 || !(isViewOnly())) && (
                    <>
                        <label className='field-name'>Status Update</label>
                        <div className='status-section'>
                    {timelines && timelines.map((item, index) => (<div>
                        <div className='issue-card' style={{ height: 'auto', borderRadius: item && item.status ? '0px 12px 0px 0px' : '0px 12px' }}>
                            <span className='icon-titles' style={{ justifyContent: 'flex-start', minWidth: '25px' }}>
                                <span style={{ color: 'white', fontWeight: 'bold', backgroundColor: '#ea5933', minWidth: '100%', height: '25px', padding: !!((item.createdByUserName).split(' ')[1]) ? '5.5px' : '5px 9px', borderRadius: !!((item.createdByUserName).split(' ')[1]) ? '13px' : '25px' }}>
                                    <span>{`${((item.createdByUserName).split('')[0] || '')}${((item.createdByUserName).split(' ')[1]) ? (((item.createdByUserName).split(' ')[1] || '').split('')[0] || '') : ''}`}</span>
                                </span>
                            </span>
                            <div style={{ flex: 1, marginTop: '5px' }}>
                                <div style={{ display: 'flex', flexDirection: 'row', flex: 8, justifyContent: 'space-between' }}>
                                    <label className='comment-name'>{item.createdByUserName}</label>
                                    <label className='comment-time'>{moment(item.createdAt).format('DD MMM, YYYY, hh:mm a')}</label>
                                </div>
                                <hr style={{ marginTop: 0 }} />
                                <div style={{ display: 'flex', flexDirection: 'row', flex: 8,}}>
                                    <label className='comment-desc'>{item.comment}</label>
                                </div>
                                {item.mediaUrls && <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
                                    {item.mediaUrls.map((item,idx) => (<div className='comment-img' onClick={() => {
                                        setPreviewUrl(item);
                                        setPreviewOverlayVisible(true);
                                    }}>
                                    {isVideo(item) ? 
                                    <div className='player-div' style={{ backgroundColor: 'black' }}>
                                        {videoIdx.has(idx) && 
                                        <div style={{position:'relative', zIndex: 100, display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}><div className="overlay-loader"></div></div>}
                                        <ReactPlayer
                                            height={'100%'}
                                            width={'100%'}
                                            onClickPreview={() => {
                                                setPreviewUrl(item);
                                                setPreviewOverlayVisible(true);
                                            }}
                                            stopOnUnmount
                                            onBuffer={(data)=>{
                                                let idxs = new Set(videoIdx);
                                                idxs.add(idx);
                                                setVideoIdx(idxs);
                                            }}
                                            onBufferEnd={(data)=>{
                                                let idxs = new Set(videoIdx);
                                                idxs.delete(idx);
                                                setVideoIdx(idxs);
                                            }}
                                            style={{ position: 'absolute', top: 0, left:0}}
                                            url={item} 
                                        />
                                    </div>
                                    // <video width={'70px'} height={'71px'}>
                                    //     <source src={item} type="video/mp4"/>
                                    //     </video> 
                                        : <img src={item} width={'70px'} height={'71px'} onClick={() => {
                                            setPreviewUrl(item);
                                            setPreviewOverlayVisible(true);
                                        }} />}
                                    </div>))}
                                </div>}
                            </div>
                        </div>
                        {item && item.status && (
                            <div className="snag-status" style={getStatusStyle(item.status)}>
                                <label className="status-text">
                                    This issue was marked as
                                    {' '}
                                    <span style={{ ...getStatusStyle(item.status), backgroundColor: 'transparent' }}>{item.status === 'TO_BE_VERIFIED' ? 'Completed' : `${startCase(getStatusLabel(item.status).text)}`}</span>
                                    {' by '}
                                    <span style={{ ...getStatusStyle(item.status), backgroundColor: 'transparent' }}>{getCreatedByRole(item.createdByRole)}</span>
                                </label>
                            </div>
                        )}
                    </div>))}
                    {/* {issueList[0] && issueList[0].status && <div className='snag-status' style={getStatusStyle(issueList[0].status)}>
                        <label className='status-text'>This issue was marked as <span style={{...getStatusStyle(issueList[0].status), backgroundColor: 'transparent'}}>{issueList[0].status === 'TO_BE_VERIFIED' ? 'Completed' : `${startCase(getStatusLabel(issueList[0].status).text)}`}</span> by <span style={{...getStatusStyle(issueList[0].status), backgroundColor: 'transparent'}}>{issueList[0].status === 'TO_BE_VERIFIED' && baseData.role.includes('BNB_CONTRACTOR') ? 'you - Verification Pending.' : `${getStatusRole(issueList[0].nextStatusRole)}`}</span></label>
                    </div>} */}
                    {(issueList[0] && issueList[0].status && (issueList[0].status === 'TO_BE_VERIFIED' || issueList[0].status === 'MISSED_BY_CONTRACTOR')) && baseData.role.includes('BNB_SITE_ENGINEER') && !isViewOnly()  && <div style={{ display: 'flex', flexDirection: 'row', margin: '10px 0' }}>
                        
                    <div className='status-button' style={{ backgroundColor: '#ECECFA', border: '1px solid #B75130' }}  onClick={() => {
                        setNextMove('MISSED');
                        setOverlayVisible(true)
                    }}>
                            <label className='status-txt' style={{ color: '#B75130' }}>Missed</label>
                        </div>
                        <div className='status-button' style={{ backgroundColor: '#ECECFA', border: '1px solid #F12929' }}  onClick={() => {
                        setNextMove('RE_OPENED');
                        setOverlayVisible(true)
                    }}>
                            <label className='status-txt' style={{ color: '#F12929' }}>Re-open</label>
                        </div>
                        <div className='status-button' style={{ border: '1px solid #4CD3AB' }}  onClick={() => {
                        setNextMove('CLOSED');
                        setOverlayVisible(true)
                    }}>
                            <label className='status-txt'>Approved</label>
                        </div>
                    </div>}
                    {issueList[0] && issueList[0].status !== 'CLOSED' && (!isViewOnly()) && <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div className='issue-card' style={{ width: '90%', height: 'auto' }}>
                        <span onClick={()=>{
                            if(imageList.length === 10 || imageList.length > 10) {
                                setLimitToast(true);
                                return;
                            }
                            setMediaOverlayVisible(true);
                        }} className='comment-section' style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                            <img src={attachment} height={15} width={15} />
                        </span>
                        <div className='comment-input' style={{ flexDirection: 'column' }}>
                            <textarea aria-expanded={false} style={{ height: '50px' }} maxLength={250} className='field-value' value={comment} onChange={(val)=>setComment(val.target.value)}/>
                            <span className='length-indicator'>{`${comment.length}/250`}</span>
                        </div>
                    </div>
                    <span onClick={() => {
                        if(!!comment.trim() || imageList.length!==0) {
                            createTimeline();
                        }
                    }} className='comment-section' style={{ width: '10%', justifyContent: 'center', alignItems: 'center' }}>
                            <RightCircleFilled disabled={!(!!comment.trim() || imageList.length!==0)} style={{ color: !(!!comment.trim() || imageList.length!==0) ? '#ddd' : '#F15A29', height: '30px', width: '30px' }} />
                        </span>

                </div>}
                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
                    {imageProcessing && <div><div onClick={() => {
                            setImageProcessing(true);
                        }} className="upload-button">
                                <div className="loader"></div>
                            </div></div>}
                            {!!(imageList.length) && imageList.map((item,idx) => (<div className='upload-button'>
                        <span className='delete-icon' onClick={()=>{handleFileRemoval(item)
                            }} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            <img src={deleteIcon} height={12} width={12} />
                        </span>
                                
                        {isVideo(item) ? 
                        <div className='player-div' style={{ backgroundColor: 'black' }}  onClick={() => {
                            setPreviewUrl(item);
                            setPreviewOverlayVisible(true);
                        }}>
                            {videoIdx.has(idx) && 
                                <div style={{position:'relative', zIndex: 100, display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}><div className="overlay-loader"></div></div>}
                            <ReactPlayer
                                muted
                                loop
                                playing
                                onClickPreview={() => {
                                    setPreviewUrl(item);
                                    setPreviewOverlayVisible(true);
                                }}
                                height={'100%'}
                                width={'100%'}
                                stopOnUnmount
                                onBuffer={(data)=>{
                                    let idxs = new Set(videoIdx);
                                    idxs.add(idx);
                                    setVideoIdx(idxs);
                                }}
                                onBufferEnd={(data)=>{
                                    let idxs = new Set(videoIdx);
                                    idxs.delete(idx);
                                    setVideoIdx(idxs);
                                }}
                                style={{ position: 'absolute', top: 0, left:0}}
                                url={item}
                            />
                        </div>
                //         <video width={'70px'} height={'71px'}>
                //     <source src={item} type="video/mp4"/>
                //    </video> 
                            : <img src={item} width={'70px'} height={'71px'}  onClick={() => {
                                setPreviewUrl(item);
                                setPreviewOverlayVisible(true);
                            }} />}
                    </div>))}
                        </div>
                </div>
                    </>
                )}
            </div>
            {overlayVisible && <div ref={overlayRef} className='overlay-div'>
                    <span className='close-icon' onClick={()=>{
                        setImageList([]);
                        setComment('')
                        setNextMove('');
                        setOverlayVisible(false);
                        setMissingField([]);
                    }} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <img src={cancel} height={12} width={12} />
                    </span>
                    <div ref={overlayBodyRef} className='overlay-body' style={{ width: '90%', height: 'auto' }}>
                        <label className='status-txt' style={{ fontSize: '15px' }}>
                            <span style={{color: 'red'}}>*</span>
                            {getNextMoveText()}</label>
                        {missingField.includes('comment') && (<span style={{ color: 'red', fontSize: '12px' }}>Required</span>)}
                        <div className='comment-reason-input' style={{flexDirection: 'column'}}>
                            <textarea className='field-value' maxLength={250} value={comment} onChange={(val)=> {
                                if (!!(val.target.value).trim() && missingField.includes('comment')) {
                                    setMissingField(missingField.filter((i,v) => i !== 'comment'));
                                } else if (!(val.target.value).trim() && !missingField.includes('comment')) {
                                    let errorFields = missingField;
                                    errorFields.push('comment');
                                    setMissingField(errorFields);
                                }
                                setComment(val.target.value)
                            }}/>
                            <span className='length-indicator'>{`${comment.length}/250`}</span>
                        </div>

                        <span onClick={()=>{
                        }} className='status-txt overlay-attachment' style={{ fontSize: '15px' }}>
                            <span style={{color: 'red'}}>*</span>
                            Add Attachement(s):
                        </span>
                        {missingField.includes('images') && (<span style={{ color: 'red', fontSize: '12px', marginBottom: '10px', marginTop: '-5px' }}>Required</span>)}
                        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
                        <div style={{ display: 'block'}}>
                            <div onClick={() => {
                            if(imageList.length === 10 || imageList.length > 10) {
                                setLimitToast(true);
                                return;
                            }
                            setMediaOverlayVisible(true);
                            }} className="upload-button">
                            <img src={camera} className='upload-img' />
                            </div>
                        </div>
                        {imageProcessing && <div><div onClick={() => {
                        setImageProcessing(true);
                    }} className="upload-button">
                            <div className="loader"></div>
                        </div></div>}
                        {!!(imageList.length) && imageList.map((item, idx) => (<div className='upload-button'>
                        <span className='delete-icon' onClick={()=>{handleFileRemoval(item)
                            }} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            <img src={deleteIcon} height={12} width={12} />
                        </span>
                                
                        {isVideo(item) ? 
                        <div className='player-div' style={{ backgroundColor: 'black' }}>
                            {videoIdx.has(idx) && 
                                <div style={{position:'relative', zIndex: 100, display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}><div className="overlay-loader"></div></div>}
                            <ReactPlayer 
                                muted
                                loop
                                height={'100%'}
                                width={'100%'}
                                onClickPreview={() => {
                                    setPreviewUrl(item);
                                    setPreviewOverlayVisible(true);
                                }}
                                stopOnUnmount
                                playsinline={false}
                                // on={() => console.log('progress')}
                                onBuffer={(data)=>{
                                    let idxs = new Set(videoIdx);
                                    idxs.add(idx);
                                    setVideoIdx(idxs);
                                }}
                                onBufferEnd={(data)=>{
                                    let idxs = new Set(videoIdx);
                                    idxs.delete(idx);
                                    setVideoIdx(idxs);
                                }}
                                style={{ position: 'absolute', top: 0, left:0}}
                                url={item}
                            />
                        </div>
                //         <video width={'70px'} height={'71px'}>
                //     <source src={item} type="video/mp4"/>
                //    </video> 
                   : <img src={item} width={'70px'} height={'71px'} onClick={() => {
                    setPreviewUrl(item);
                    setPreviewOverlayVisible(true);
                }} />}
                    </div>))}
                        </div>
                <button disabled={loading} onClick={() => {
                    let errorFields = missingField;
                    if (!comment.trim() && !missingField.includes('comment')) {
                            errorFields.push('comment');
                        }
                    if (imageList.length === 0 && !missingField.includes('images')) {
                            errorFields.push('images');
                        }
                    if (errorFields.length !== 0) {
                        setMissingField(errorFields);
                    } else {
                        createTimeline();
                    }
                }} className='status-button'  style={{ backgroundColor: (loading || !!(missingField.length)) ? '#ddd' : '#F15A29', border: '0px solid transparent', marginBottom: '10px', marginTop: '20px', minHeight: '35px', minWidth: '100px', fontSize: '15px'  }}>Submit</button>
                </div>
            </div>}
            {previewOverlay && previewUrl && <div ref={overlayRef} className='overlay-div'>
                <span className='preview-close' onClick={()=>{
                        setPreviewUrl(null);
                        setPreviewOverlayVisible(false);
                    }}>
                        <img src={cancel} height={12} width={12} />
                    </span>
                {isVideo(previewUrl) ? 
                            <div className='player-div' style={{ backgroundColor: 'black' }}>
                                <ReactPlayer 
                                    muted
                                    loop
                                    playing
                                    controls
                                    width={'100%'}
                                    stopOnUnmount
                                    url={previewUrl}
                                />
                            </div>
                    //         <video width={'70px'} height={'71px'}>
                    //     <source src={item} type="video/mp4"/>
                    //    </video> 
                    : <img src={previewUrl} width={'100%'}/>}
            </div>}
            {mediaOverlay && <div className='overlay-div'>
                <span className='close-icon' onClick={()=>{
                    setMissingField([]);
                    setImageProcessing(false);
                    setMediaOverlayVisible(false);
                }} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', top: '42%' }}>
                    <img src={cancel} height={12} width={12} />
                </span>
                <div className='overlay-body' style={{ width: '90%', borderRadius: '12px' }}>
                    <label className='status-txt' style={{ backgroundColor: 'white', textAlign: 'center', marginBottom: '5px', fontWeight: 'bold' }}>Select Action</label>
                    <div style={{display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
                        <div onClick={() => {
                            setImageProcessing(true);
                            // eslint-disable-next-line no-undef
                            android.getVideoUrlFromAndroid();
                            setMediaOverlayVisible(false);
                        }} className='status-button'
                        style={{ border: '1px solid #F15A29', color: '#F15A29', width: '40%', borderRadius: '5px', backgroundColor: 'white' }}>Add Videos</div>
                        <div onClick={() => {
                            setImageProcessing(true);
                            // eslint-disable-next-line no-undef
                            android.getPhotoUrlFromAndroid();
                            setMediaOverlayVisible(false);
                        }} className='status-button'
                        style={{ backgroundColor: '#F15A29', width: '40%', borderRadius: '5px' }}>Add Photos</div>
                    </div>
                </div>
            </div>}
            {limitToast && <div className='overlay-div' style={{ display: 'flex', justifyContent: 'flex-end', backgroundColor: 'transparent'}}>
                <label className='toast'>{'Max limit reached.'}</label>
            </div>}

            {loading && <div className='overlay-div'>
                <div className="overlay-loader"></div>
            </div>}

            {errorToast && <div className='overlay-div' style={{ display: 'flex', justifyContent: 'flex-end', backgroundColor: 'transparent'}}>
                <label className='toast'>{'Something went wrong.'}</label>
            </div>}
            {issueList[0] && issueList[0].status && (issueList[0].status === 'OPEN' || issueList[0].status === 'RE_OPENED') && issueList[0].nextStatusList && issueList[0].nextStatusList[0] && baseData.role.includes('BNB_CONTRACTOR') && (!isViewOnly()) && <div className='overlay-btn-grp'>
                {issueList[0].nextStatusList && issueList[0].nextStatusList.map((item) => <div className='status-button' style={{ backgroundColor: item === 'TO_BE_VERIFIED' ? '#F15A29' : 'transparent', fontSize: '12px', padding: '5px 10px', minWidth: '100px', minHeight: '35px'  }} onClick={() => {
                    setNextMove(item);
                    setOverlayVisible(true)
                }}>
                    <label className='status-txt' style={{ color: item === 'TO_BE_VERIFIED' ? 'white' : '#F15A29', fontSize: '15px', textAlign: 'center' }}>{item!== 'TO_BE_VERIFIED' && <span><img style={{ marginLeft: '-5px', marginRight: '2px'}} src={tick} height={'8px'} width={'8px'} /></span>}{item === 'TO_BE_VERIFIED' ? `Complete ${issueList[0] && issueList[0].issueType==='SNAG' ? 'Snag' : 'Hitch'}` : " Can't be Completed"}</label>
                </div>)}
            </div>}
        </div>
        </div>
    )
};

export default IssueDetails;